import { Application } from "stimulus";
import FieldFocusController from "./controllers/field_focus_controller";

const application = Application.start();
application.register("field-focus", FieldFocusController);

if (document.querySelector('[data-controller="onboarding"]')) {
	import("./controllers/onboarding_controller").then(({ default: OnboardingController }) => {
		application.register("onboarding", OnboardingController);
	});
}

if (document.querySelector('[data-camera-target]')) {
	import("./modules/camera").then((mod) => {
		if (mod && mod.default) mod.default();
	});
}

import("./modules/offline_queue").then((mod) => {
	if (mod && mod.initOfflineQueue) mod.initOfflineQueue();
});

import("./modules/pwa_install").then((mod) => {
	if (mod && mod.initPwaInstall) mod.initPwaInstall();
});

document.addEventListener('DOMContentLoaded', function () {
	const banners = document.querySelectorAll('.alert-dismissible, .service-status-banner, .flash-stack .alert');
	banners.forEach(banner => {
		banner.addEventListener('show.bs.alert', () => {
			banners.forEach(b => {
				if (b !== banner) b.classList.remove('show');
			});
		});
		const closeBtn = banner.querySelector('.btn-close');
		if (closeBtn) {
			closeBtn.addEventListener('click', () => {
				banners.forEach(b => {
					if (b !== banner) b.classList.remove('show');
				});
			});
		}
	});

	const helpDock = document.querySelector('.help-dock');
	if (helpDock) {
		function updateHelpDock() {
			const scrollY = window.scrollY || window.pageYOffset;
			const windowHeight = window.innerHeight;
			const docHeight = document.documentElement.scrollHeight;
			if (window.matchMedia('(max-width: 768px)').matches) {
				if (scrollY + windowHeight >= docHeight - 2) {
					helpDock.classList.add('help-dock--expanded');
				} else {
					helpDock.classList.remove('help-dock--expanded');
				}
			} else {
				helpDock.classList.remove('help-dock--expanded');
			}
		}
		window.addEventListener('scroll', updateHelpDock);
		window.addEventListener('resize', updateHelpDock);
		updateHelpDock();
	}
});
